import { HttpClient } from '@angular/common/http';
import * as g from 'src/app/globals';
import { EventEmitter, Injectable } from '@angular/core';
import { ParameterValueChangedArgs } from './dashboard';
import { FilterFieldValue, WidgetFieldValue } from '../subscription/classes';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  parameterValueChanged: EventEmitter<ParameterValueChangedArgs> = new EventEmitter();

  constructor(private http: HttpClient) { }

  getDashboard(dashboardId: number) {
    return this.http.get(`${g.apiBaseUrl}layout/dashboard?id=${dashboardId}`);
  }

  getWidgetStructure(widgetId: number) {
    return this.http.get(`${g.apiBaseUrl}layout/widget?id=${widgetId}`);
  }

  getWidgetData(widgetId: number, filterData: WidgetFieldValue[], exportToExcel: boolean) {
    return this.http.get(`${g.apiBaseUrl}data/widget?id=${widgetId}&exportToExcel=${exportToExcel}&queryParams=${JSON.stringify(filterData)}`).toPromise();
  }

  getSelectValues(
    fieldId: number,
    sqlId: number,
    args: string[],
    vals: string[]
  ) {
    return this.http.get(
      `${
        g.apiBaseUrl
      }data/GetPropertySource?fieldId=${fieldId}&sqlId=${sqlId}&args=${args}&vals=${vals}`
    );
  }

  triggerParameterValueChanged(args: ParameterValueChangedArgs) {
    this.parameterValueChanged.emit(args);
  }
}
